var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSlate } from "slate-react";
import { Button, Icon } from "../BaseComponents";
import { isMarkActive } from "../../plugins/helpers/isMarkActive";
import { toggleMark } from "../../plugins/helpers/toggleMark";
import { css } from "@emotion/css";
import Description from "../Description/Description";
var MarkButton = function (_a) {
    var format = _a.format, icon = _a.icon, description = _a.description;
    var editor = useSlate();
    return (_jsxs(Button, __assign({ className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        position: relative;\n        &:hover {\n          .tag {\n            display: block;\n          }\n        }\n      "], ["\n        position: relative;\n        &:hover {\n          .tag {\n            display: block;\n          }\n        }\n      "]))), active: isMarkActive(editor, format), onMouseDown: function () {
            toggleMark(editor, format);
        } }, { children: [_jsx(Description, { description: description }), _jsx(Icon, { children: icon })] })));
};
export default MarkButton;
var templateObject_1;
